<template>
  <div class="MaintainStatus">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div
          style="width:100vw"
        >
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">即時維修狀態</span>
              </b-col>
              <b-col cols="12" class="mx-0 text-right" style="margin-top: 2rem">
                <exportCsv />
              </b-col>
              <b-col cols="12" class="mx-0" style="margin-top: 1rem">
                <div
                  style="
                    width: 100%;
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                    padding: 7.2px;
                  "
                >
                  <span>梓官廠當前報修機台</span>
                </div>
                <b-table
                  sticky-header
                  :items="maintainStatusZiguan"
                  :fields="maintainStatusFields"
                  :no-border-collapse="noCollapse"
                  responsive
                  class="maintain-status-table-detail"
                >
                </b-table>
              </b-col>
              <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                <div
                  style="
                    width: 100%;
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                    padding: 7.2px;
                  "
                >
                  <span>橋頭廠當前報修機台</span>
                </div>
                <b-table
                  sticky-header
                  :items="maintainStatusQiaotou"
                  :fields="maintainStatusFields"
                  :no-border-collapse="noCollapse"
                  responsive
                  class="maintain-status-table-detail"
                >
                </b-table>
              </b-col>
            </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import $ from "jquery";
import exportCsv from "@/components/exportCsv.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MaintainStatus",
  data() {
    return {
      maintainStatusFields: [
        {
          key: "device",
          label: "機台",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "model",
          label: "型號",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "startTime",
          label: "報修時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "reason",
          label: "報修原因",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "accumulation",
          label: "維修累積時間",
          sortable: false,
          class: "font-family-dfyuanstd-w5",
        },
      ],
      maintainStatusZiguan: [],
      maintainStatusQiaotou: [],
    };
  },
  created: function () {
    let vm = this;
    vm.getMaintainData();
  },
  mounted: function () {},
  components: {
    exportCsv,
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      show_loadScreenModal: "loadscreenmodal/show_loadScreenModal",
      hide_loadScreenModal: "loadscreenmodal/hide_loadScreenModal",
      set_exportExcelFileName: "exportcsv/set_exportExcelFileName",
      set_exportExcelData: "exportcsv/set_exportExcelData",
    }),
    getMaintainData() {
      let vm = this;
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "Query_Maintain_Status";
      vm.show_loadScreenModal();
      vm.axiosAction(params).then(() => {
        vm.hide_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          vm.maintainStatusZiguan = result.QueryTableData.maintain_data_Ziguan;
          vm.maintainStatusQiaotou =
            result.QueryTableData.maintain_data_Qiaotou;
          vm.setExportExcelData(vm.maintainStatusFields, result.QueryTableData);
        }
      });
    },
    setExportExcelData(title, data) {
      if (
        data.maintain_data_Ziguan.length == 0 &&
        data.maintain_data_Qiaotou.length == 0
      ) {
        return;
      }
      let vm = this;
      let fileName = "即時維修狀態" + data.query_time;
      let titleField = [];
      let titleKey = [];
      title.forEach((item) => {
        titleKey.push(item.key);
        titleField.push(item.label);
      });
      let setExportData = [];
      Object.keys(data).forEach((item) => {
        if (item == "query_time") {
          return;
        }
        let exportData = [];
        data[item].forEach((rowData) => {
          let singleRowData = [];
          titleKey.forEach((key) => {
            singleRowData.push(rowData[key]);
          });
          exportData.push(singleRowData);
        });
        let sheetName = "";
        if (item == "maintain_data_Ziguan") {
          sheetName = "梓官廠機台報修紀錄";
        } else if (item == "maintain_data_Qiaotou") {
          sheetName = "橋頭廠機台報修紀錄";
        }
        let exportObj = {
          sheetName: sheetName,
          title: titleField,
          data: exportData,
        };
        setExportData.push(exportObj);
      });
      vm.set_exportExcelData(setExportData);
      vm.set_exportExcelFileName(fileName);
    },
    clearExportExcel() {
      let vm = this;
      vm.set_exportExcelData([]);
      vm.set_exportExcelFileName("");
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    let vm = this;
    vm.clearExportExcel();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss">
.maintain-status-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.maintain-status-table-detail th,
.maintain-status-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.maintain-status-table-detail th {
  border-top: none !important;
}
.maintain-status-table-detail th:first-child,
.maintain-status-table-detail td:first-child {
  border-left: 1px solid;
}
.maintain-status-table-detail {
  margin-bottom: 0px;
}
.maintain-status-table-detail thead th {
  font-size: 1rem;
  color: #000000 !important;
  background-color: #cccccc !important;
}
.maintain-status-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.maintain-status-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/maintainStatus.vue